module.exports = __webpack_public_path__ + "static/WEDDING E&M-275-22570111feaa09d15f77380aae4cae24.jpg";